const GITHUB_USERNAME = "abbiekuma";

const ALLOWED_REPOS = [
  "ABS-Challenge-Analyzer",
  "MoodStream",
  "scroll-duel",
  "doggy-diary",
];

const MANUAL_PROJECTS = [
  {
    id: "private-1",
    name: "Quizly",
    description:
      "An AI-powered study app built on the Google Gemini API: learn a topic in Beginner or Deep-dive mode, then quiz yourself with auto-generated multiple-choice questions. Starred quizzes are kept even after chats are deleted, backed by a PostgreSQL + Drizzle data model.",
    language: "TypeScript",
    url: "https://github.com/abbiekuma/ai-study-helper",
    isPrivate: true,
  },
];

let projectsCache = null;
let projectsPromise = null;

function normalizeRepos(data) {
  const fromGitHub = data
    .filter((repo) => ALLOWED_REPOS.includes(repo.name))
    .sort(
      (a, b) => ALLOWED_REPOS.indexOf(a.name) - ALLOWED_REPOS.indexOf(b.name),
    )
    .map((repo) => ({
      id: repo.id,
      name: repo.name,
      description: repo.description,
      language: repo.language,
      url: repo.html_url,
      stars: repo.stargazers_count,
      isPrivate: false,
    }));

  return [...MANUAL_PROJECTS, ...fromGitHub];
}

export function getCachedProjectsData() {
  return projectsCache;
}

export async function fetchProjectsData() {
  if (projectsCache) return projectsCache;
  if (projectsPromise) return projectsPromise;

  projectsPromise = fetch(
    `https://api.github.com/users/${GITHUB_USERNAME}/repos?per_page=100`,
  )
    .then((res) => {
      if (!res.ok) throw new Error("Failed to fetch repos");
      return res.json();
    })
    .then((data) => ({
      repos: normalizeRepos(data),
      error: null,
    }))
    .catch((err) => ({
      repos: MANUAL_PROJECTS,
      error: err.message,
    }))
    .then((result) => {
      projectsCache = result;
      projectsPromise = null;
      return result;
    });

  return projectsPromise;
}

export function preloadProjectsData() {
  void fetchProjectsData();
}
